<template>
  <div class="pa-2">
    <layout-sub-modulo>
      <template #title>Información empleados activos</template>

      <template #filtro>
        <RegistrarFiltro
          v-model="filtrosLocales"
          :empresas="listados.empresas"
          :convenios="listados.convenios"
          :sucursales="filtros.sucursales"
          :tipos-contratos="listados.tiposContratos"
          @convenio-change="listarEmpleados"
          @empresa-change="cambiarEmpresaFiltro"
          @aplicar-filtros="aplicarFiltrosEmpleados"
          @limpiar="limpiarFiltro"
        />
      </template>

      <template #body>
        <EmpleadosTab
          :search="filtros.search"
          :tabla-esta-visible="tablaEmpleados.tablaVisible"
          :lista-empleados="tablaEmpleados.visibles"
          :datos-usuario="datosUsuario"
          :cargando="tablaEmpleados.cargando"
          :puede-ver-salario="permisosRegistroDatos.puedeVerSalario"
          :puede-registrar-empleado="
            permisosRegistroDatos.puedeRegistrarEmpleado
          "
          @update:search="filtros.search = $event"
          @register-click="abrirModalRegistro"
          @excel-descargar="descargarExcel"
          @refrescar="listarEmpleados"
          @edit-item="editarEmpleado"
          @ver-cartera="verCartera"
        />

        <div
          v-if="!tablaEmpleados.tablaVisible && filtros.empresa"
          class="d-flex justify-center align-center pt-5"
        >
          <v-alert
            outlined
            type="info"
            border="bottom"
            class="mx-3"
            style="width: 700px"
          >
            La visualización de los datos para la empresa
            <span style="font-weight: bold">{{
              filtros.empresa.razon_social
            }}</span>
            se encuentra desactualizada, por favor comuníquese con
            <span style="font-weight: bold">{{
              $store.state.nombrePlataforma
            }}</span>
            para obtener más información.
          </v-alert>
        </div>
      </template>
    </layout-sub-modulo>

    <ModalFormEmpleado
      :tiene-dialogo-abierto="modalEmpleado.estaAbierto"
      :convenio="filtros.convenio"
      :empresas="listados.empresas"
      :tipos-documentos="listados.tiposDocumentos"
      :tipos-contratos="listados.tiposContratos"
      :es-edicion="modalEmpleado.esEdicion"
      :resultado-cartera="modalEmpleado.totalCartera"
      :sucursales="modalEmpleado.sucursales"
      :puede-ver-salario="permisosRegistroDatos.puedeVerSalario"
      :puede-editar-empleado="permisosRegistroDatos.editarEmpleado"
      :puede-registrar-empleado="permisosRegistroDatos.puedeRegistrarEmpleado"
      :puede-bloquear-empleado="permisosRegistroDatos.bloquearEmpleado"
      @guardar="guardarEmpleado"
      @cancelar="cerrarModalRegistro"
      @cambiar-compania="cambiarCompaniaModal"
      @validar-documento="verificarExistenciaEmpleado"
      ref="componenteModal"
    />
    <ModalCartera
      :visible="cartera.dialogoAbierto"
      :empleado="cartera.empleadoSeleccionado"
      @close="cerrarModalCartera"
    >
      <TablaCarteraCompanias
        v-if="cartera.tabActivo === 0"
        :cargando="cartera.cargando"
        :companias="cartera.companias"
        @ver-detalle="verDetalleCxC"
      />
      <TablaCarteraDocumentos
        v-if="cartera.tabActivo === 1"
        :cargando="cartera.cargando"
        :documentos="cartera.documentos"
        :razon-social="cartera.razonSocial"
        @volver="volverCartera"
      />
    </ModalCartera>
  </div>
</template>

<script>
import { registroDatosMixin } from '../../../mixins/Permisos/Empleados/registroDatosMixin';
import { alertSuccess } from '../../../plugins/sweetalert2';
import empleadosService from '../../../Services/empleadoService';
import empresaService from '../../../Services/empresaService';
import logService from '../../../Services/logService';
import servicesGeneric from '../../../Services/Integraciones/genericTransferService';
import tipoDocumentoService from '../../../Services/tipoDocumentoService';
import tipoContratoService from '../../../Services/tipoContratoService';
import usuarioService from '../../../Services/usuarioService';
import { empresaEstaActualizada } from '../../../utils/actualizacionEmpresaUtil';
import { alertInfo, alertError } from '../../../utils/alertUtil';
import { getRol } from '../../../utils/permisosUtil';
import { formatterMoney } from '../../../utils/formatearMonedaUtil';
import LayoutSubModulo from '../../../components/Layout/SubModulo.vue';
import {
  crearMapaEmpresas,
  mapearConvenios,
  mapearEmpleadosConvenio,
  mapearSucursales,
} from './Helper/empleadoFormatoHelper';
import {
  aplicarFiltros,
  calcularDisponibleInicial,
  construirPayloadEmpleado,
  filtrarEmpleadosPorEmpresaActualizada,
  sumarSaldosCxC,
} from './Helper/empleadoHelper';
import { descargarExcelEmpleados } from './Reports/datosEmpleados';
import RegistrarFiltro from './Forms/RegistrarFiltro.vue';
import EmpleadosTab from './Partials/EmpleadosTab.vue';
import ModalCartera from './Modal/ModalCartera.vue';
import ModalFormEmpleado from './Modal/ModalFormEmpleado.vue';
import TablaCarteraCompanias from './Table/TablaCarteraCompanias.vue';
import TablaCarteraDocumentos from './Table/TablaCarteraDocumentos.vue';

const crearFiltrosIniciales = () => ({
  empresa: null,
  convenio: null,
  sucursal: null,
  sucursales: [],
  tipoContrato: null,
  estadoEmpleado: null,
  estadoCartera: null,
  search: null,
});

export default {
  name: 'RegistrarDatos',

  components: {
    EmpleadosTab,
    LayoutSubModulo,
    RegistrarFiltro,
    ModalFormEmpleado,
    ModalCartera,
    TablaCarteraCompanias,
    TablaCarteraDocumentos,
  },

  mixins: [registroDatosMixin],

  data() {
    return {
      filtros: crearFiltrosIniciales(),

      listados: {
        empresas: [],
        convenios: [],
        tiposDocumentos: [],
        tiposContratos: [],
      },

      tablaEmpleados: {
        originales: [],
        visibles: [],
        tablaVisible: true,
        cargando: false,
        mapaEmpresas: new Map(),
      },

      modalEmpleado: {
        estaAbierto: false,
        esEdicion: false,
        totalCartera: '',
        sucursales: [],
      },

      cartera: {
        dialogoAbierto: false,
        empleadoSeleccionado: {},
        companias: [],
        documentos: [],
        tabActivo: 0,
        razonSocial: '',
        cargando: false,
      },

      datosUsuario: {},
    };
  },

  computed: {
    filtrosCompletos() {
      const empresasUsuario = this.datosUsuario.empresas;
      if (!empresasUsuario) return false;
      if (empresasUsuario.length === 0) return true;
      return this.filtros.convenio !== null;
    },

    filtrosLocales: {
      get() {
        return {
          convenio: this.filtros.convenio,
          empresa: this.filtros.empresa,
          sucursal: this.filtros.sucursal,
          tipoContrato: this.filtros.tipoContrato,
          estadoEmpleado: this.filtros.estadoEmpleado,
          estadoCartera: this.filtros.estadoCartera,
        };
      },
      set(valor) {
        Object.assign(this.filtros, valor);
      },
    },
  },

  created() {
    this.cargarDatosIniciales();
  },

  methods: {
    async cargarDatosIniciales() {
      await Promise.all([
        this.listarTipoDocumentos(),
        this.obtenerTiposContrato(),
        this.listarEmpresas(),
      ]);

      await this.obtenerDatosUsuario();

      await this.listarEmpleados();
    },

    async obtenerDatosUsuario() {
      const idUsuario = this.$store.state.usuario._id;
      this.datosUsuario = await usuarioService.getUser(idUsuario);
      await this.listarConvenios();
    },

    async listarConvenios() {
      const respuesta = await empresaService.buscarTodos({
        tieneConvenio: true,
      });

      if (!respuesta?.data || !this.datosUsuario?.empresas) {
        this.listados.convenios = [];
        return;
      }

      this.listados.convenios = mapearConvenios(
        respuesta.data,
        this.datosUsuario.empresas
      );
    },

    async listarTipoDocumentos() {
      try {
        this.listados.tiposDocumentos =
          await tipoDocumentoService.buscarTodos();
      } catch {
        this.listados.tiposDocumentos = [];
      }
    },

    async listarEmpresas() {
      const empresas = await empresaService.buscarTodos();
      this.listados.empresas = empresas?.data ?? [];
      this.tablaEmpleados.mapaEmpresas = crearMapaEmpresas(
        this.listados.empresas
      );
    },

    async obtenerTiposContrato() {
      const { token } = this.$store.state;
      this.listados.tiposContratos = await tipoContratoService.buscarTodosConRol(
        token,
        getRol(this.permisosRegistroDatos.registrarDatos)
      );
    },

    async obtenerSucursales() {
      const nitEmpresa = this.filtros.empresa?.nit;
      if (!nitEmpresa) {
        this.filtros.sucursales = [];
        return;
      }

      const sucursales = await empresaService.buscarSucursales(nitEmpresa);

      if (!sucursales) {
        return;
      }

      const listaSucursales = Array.isArray(sucursales)
        ? sucursales
        : sucursales?.sucursales ?? [];
      this.filtros.sucursales = listaSucursales;
    },

    async cargarEmpleadosEmpresa(empresa) {
      if (!empresaEstaActualizada(empresa)) {
        this.tablaEmpleados.tablaVisible = false;
        return;
      }
      const filtros = {
        nit: empresa.nit,
        estaRetirado: false,
      };
      const empleadosEmpresa = await empleadosService.buscarTodos(filtros);
      if (!empleadosEmpresa) return;
      this.tablaEmpleados.originales = empleadosEmpresa?.data ?? [];
    },

    async cargarTodosEmpleados() {
      const filtros = { estaRetirado: false };
      const empleados = await empleadosService.buscarTodos(filtros);
      if (!empleados) return;
      this.tablaEmpleados.originales = filtrarEmpleadosPorEmpresaActualizada(
        empleados.data,
        this.tablaEmpleados.mapaEmpresas,
        empresaEstaActualizada
      );
    },

    async listarEmpleados() {
      this.tablaEmpleados.tablaVisible = true;
      this.tablaEmpleados.cargando = true;
      this.tablaEmpleados.originales = [];
      this.tablaEmpleados.visibles = [];
      if (!this.filtrosCompletos) {
        this.tablaEmpleados.cargando = false;
        return;
      }

      await (this.filtros.empresa
        ? this.cargarEmpleadosEmpresa(this.filtros.empresa)
        : this.cargarTodosEmpleados());

      if (this.filtros.convenio) {
        this.tablaEmpleados.originales = mapearEmpleadosConvenio(
          this.tablaEmpleados.originales
        );
      }

      this.tablaEmpleados.visibles = [...this.tablaEmpleados.originales];
      this.aplicarFiltrosEmpleados();
      this.tablaEmpleados.cargando = false;
    },

    async obtenerTotalCuentasPorCobrar(idCompania, numeroDocumento) {
      const cuentasPorCobrar = await this.obtenerCuentasPorCobrar(
        idCompania,
        numeroDocumento
      );
      if (!cuentasPorCobrar?.length) {
        this.modalEmpleado.totalCartera = '';
        return;
      }
      const totalCxC = sumarSaldosCxC(cuentasPorCobrar);
      this.modalEmpleado.totalCartera = formatterMoney(totalCxC, 0);
    },

    aplicarFiltrosEmpleados() {
      const filtros = {
        tipoContrato: this.filtros.tipoContrato,
        sucursal: this.filtros.sucursal,
        estadoCartera: this.filtros.estadoCartera,
        estadoEmpleado: this.filtros.estadoEmpleado,
      };
      this.tablaEmpleados.visibles = aplicarFiltros(
        this.tablaEmpleados.originales,
        filtros
      );
    },

    async guardarEmpleado(formData) {
      const esEdicion = formData.esEdicion;
      const disponible = esEdicion
        ? formData.disponible
        : calcularDisponibleInicial(formData);
      const payload = construirPayloadEmpleado(formData, disponible);

      const response = esEdicion
        ? await empleadosService.actualizar(formData._id, payload)
        : await empleadosService.crear(payload);

      if (!response) return;

      await this.crearLog(
        formData.tipoEvento,
        formData.descripcionTipo,
        formData
      );

      this.$refs.componenteModal?.cerrarModal();
      this.modalEmpleado.estaAbierto = false;
      this.modalEmpleado.esEdicion = false;

      alertSuccess(
        esEdicion
          ? 'Empleado actualizado correctamente'
          : 'Empleado creado correctamente'
      );
      this.listarEmpleados();
    },

    async editarEmpleado(empleado) {
      this.modalEmpleado.esEdicion = true;
      this.modalEmpleado.estaAbierto = true;
      this.calcularTotalCuentasPorCobrar(empleado.NumeroDocumento);

      const respuesta = await empleadosService.buscarPorDocumento(
        empleado.NumeroDocumento
      );
      const datosEmpleado = respuesta?.data || respuesta;
      if (!datosEmpleado || datosEmpleado.msg === 'Not found') {
        this.modalEmpleado.esEdicion = false;
        this.modalEmpleado.estaAbierto = false;
        return;
      }

      const compania = this.buscarEmpresaPorNit(datosEmpleado.NitCompañia);
      if (compania?.nit) {
        this.modalEmpleado.sucursales = await this.cargarSucursales(
          compania.nit
        );
      }

      this.$refs.componenteModal?.abrirModal(datosEmpleado);
    },

    async crearLog(tipoEvento, descripcionTipo, formData) {
      const { usuario } = this.$store.state;
      const descripcionEvento = `${descripcionTipo} ${formData.tipoDocumento} : ${formData.numeroDocumento}`;

      const body = {
        NitCompañia: formData.nitCompañia,
        DescCompañia: formData.descCompañia,
        IdSucursal: formData.idSucursal,
        DescripcionSucursal: formData.descripcionSucursal,
        NombreUser: usuario.nombre,
        Email: usuario.email,
        Evento: tipoEvento,
        DescripcionEvento: descripcionEvento,
      };

      await logService.crear(body);
    },

    calcularTotalCuentasPorCobrar(numeroDocumento) {
      if (!this.filtros.convenio?.compania_id) return;
      this.obtenerTotalCuentasPorCobrar(
        this.filtros.convenio.compania_id,
        numeroDocumento
      );
    },

    buscarEmpresaPorNit(nitCompania) {
      const nitEmpresaEmpleado = Number.parseInt(nitCompania, 10);
      if (Number.isNaN(nitEmpresaEmpleado)) return null;
      return this.tablaEmpleados.mapaEmpresas.get(nitEmpresaEmpleado) ?? null;
    },

    async cargarSucursales(nitEmpresa) {
      const resultado = await empresaService.buscarSucursales(nitEmpresa);
      return mapearSucursales(
        Array.isArray(resultado) ? resultado : resultado?.sucursales
      );
    },

    async verificarExistenciaEmpleado(numeroDocumento) {
      if (!numeroDocumento) return;
      const filtro = { numeroDocumento };
      const respuesta = await empleadosService.buscarTodos(filtro);
      if (respuesta?.data?.length) {
        await alertInfo('El empleado ya está registrado');
      }
    },

    async verCartera(item) {
      this.cartera.empleadoSeleccionado = item;
      this.cartera.companias = [];
      this.cartera.documentos = [];
      this.cartera.tabActivo = 0;
      this.cartera.razonSocial = '';
      this.cartera.dialogoAbierto = true;

      if (!this.filtros.convenio?.compania_id) return;

      this.cartera.cargando = true;
      const { compania_id: companiaId } = this.filtros.convenio;

      const cuentas = await this.obtenerCuentasPorCobrar(
        companiaId,
        item.NumeroDocumento
      );

      if (cuentas?.length) {
        const total = sumarSaldosCxC(cuentas);
        this.cartera.companias = [
          {
            ...this.filtros.convenio,
            totalCartera: formatterMoney(total, 0),
          },
        ];
      }

      this.cartera.cargando = false;
    },

    async verDetalleCxC(compania) {
      const { compania_id: companiaId, razon_social: razonSocial } = compania;
      this.cartera.documentos = [];
      this.cartera.razonSocial = razonSocial;
      this.cartera.tabActivo = 1;
      this.cartera.cargando = true;

      try {
        const cuentas = await this.obtenerCuentasPorCobrar(
          companiaId,
          this.cartera.empleadoSeleccionado.NumeroDocumento
        );

        if (cuentas?.length) {
          this.cartera.documentos = cuentas.map(cuenta => ({
            ...cuenta,
            Saldo: formatterMoney(
              Number(cuenta.Saldo?.replace(',', '.'))
            ),
          }));
        }
      } finally {
        this.cartera.cargando = false;
      }
    },

    async obtenerCuentasPorCobrar(idCompania, numeroDocumento) {
      try {
        const { tokenAPI } = this.$store.state;
        return await servicesGeneric.buscarCxCPorCompania(
          idCompania,
          numeroDocumento,
          tokenAPI
        );
      } catch {
        return [];
      }
    },

    async cambiarEmpresaFiltro() {
      this.filtros.sucursal = null;
      this.filtros.sucursales = [];
      if (!this.filtros.empresa?.nit) {
        await this.listarEmpleados();
        return;
      }
      await Promise.all([this.obtenerSucursales(), this.listarEmpleados()]);
    },

    abrirModalRegistro() {
      this.$refs.componenteModal?.cerrarModal();
      this.modalEmpleado.esEdicion = false;
      this.modalEmpleado.totalCartera = '';
      this.modalEmpleado.estaAbierto = true;
    },

    cerrarModalRegistro() {
      this.$refs.componenteModal?.cerrarModal();
      this.modalEmpleado.estaAbierto = false;
      this.modalEmpleado.esEdicion = false;
    },

    async cambiarCompaniaModal(compania) {
      if (!compania?.nit) {
        this.modalEmpleado.sucursales = [];
        return;
      }
      this.modalEmpleado.sucursales = await this.cargarSucursales(compania.nit);
    },

    async descargarExcel() {
      try {
        await descargarExcelEmpleados(
          this.tablaEmpleados.visibles,
          this.filtros.convenio
        );
      } catch {
        alertError('No fue posible descargar el archivo de empleados');
      }
    },

    volverCartera() {
      this.cartera.tabActivo = 0;
      this.cartera.razonSocial = '';
    },

    cerrarModalCartera() {
      this.cartera.dialogoAbierto = false;
      this.cartera.tabActivo = 0;
      this.cartera.razonSocial = '';
    },

    limpiarFiltro() {
      this.filtros = crearFiltrosIniciales();
      this.listarEmpleados();
    },
  },
};
</script>
